<template>
    <el-card class="box-card" shadow="always">
        <div class="form-item">
            <span class="label">*所属分类</span>
            <el-select v-model="seoInfo.case_class_id" class="icon_type">
                <el-option v-for="(item,index) in caseClassList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
        </div>

        <div class="form-item">
            <span class="label">*案例标题</span>
            <el-input v-model="seoInfo.case_title" clearable style="width: 300px" class="name-input" placeholder="请输入案例标题" />
        </div>

        <div class="form-item">
            <span class="label">*案例封面:</span>
            <div>
                <imageUpload v-model="seoInfo.case_img" :limit="1" />
                <div class="el-upload__tip">建议尺寸为346*240</div>
            </div>
        </div>

        <div class="form-item">
            <span class="label">自定义ALT</span>
            <el-input v-model="seoInfo.case_icon_alt" clearable style="width: 300px" class="name-input" placeholder="请输入自定义ALT" />
        </div>

        <div>
            <div class="seo_set">*SEO配置</div>
            <div class="seo_wrap">
                <div class="form-item">
                    <span class="label">*页面标题：</span>
                    <el-input v-model="seoInfo.seo_t" clearable style="width: 300px" class="name-input" placeholder="请输入页面标题：" />
                </div>

                <div class="form-item">
                    <span class="label co_w">*描述：</span>
                    <el-input v-model="seoInfo.seo_d" clearable style="width: 300px" class="name-input" placeholder="请输入描述" />
                </div>

                <div class="form-item">
                    <span class="label co_w">*关键词：</span>
                    <el-input v-model="seoInfo.seo_k" clearable style="width: 300px" class="name-input" placeholder="请输入关键词" />
                </div>
            </div>
        </div>
    </el-card>
</template>
<script>
import { getCaseClass } from '@/api/case';
import utils from '@/jslibs/utils';
import imageUpload from '@/components/ImageUpload';
export default {

    components: {
        imageUpload
    },
    data() {
        return {
            loading: false,
            seoInfo: {
                case_class_id: "",
                case_title: "",
                case_icon: "",
                case_img: [],
                case_icon_alt: "",
                seo_t: "",
                seo_d: "",
                seo_k: ""
            },
            caseClassList: []
        };
    },
    mounted() {
        this.getCaseClass()
    },
    methods: {
        async getCaseClass() {
            const postData = { page_index: 1, page_size: 999 }
            const { data } = await getCaseClass(postData);
            this.caseClassList = data;
        },

        verifyInput() {
            const { case_class_id, case_title, case_img, case_icon_alt, seo_t, seo_d, seo_k } = this.seoInfo;
            if (!case_class_id) {
                this.$notify.error({ title: '请选择所属分类' });
                return false
            }
            if (!case_title) {
                this.$notify.error({ title: '请输入案例标题' });
                return false
            }
            if (!case_img.length) {
                this.$notify.error({ title: '请上传封面案例图' });
                return false
            }
            if (!seo_t) {
                this.$notify.error({ title: '请输入页面标题' });
                return false
            }
            if (!seo_d) {
                this.$notify.error({ title: '请输入seo描述' });
                return false
            }
            if (!seo_k) {
                this.$notify.error({ title: '请输入seo关键词' });
                return false
            }
            this.seoInfo.case_icon = this.seoInfo.case_img.join();
            return true
        }
    }
};
</script>
<style lang="less" scoped>
    .box-card{
        .form-item {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .icon_type{
                margin-right: 20px;
            }
        }
        .label {
            display: inline-block;
            width: 80px;
            flex-shrink: 0;
        }
        .el-select{
            width: 300px;
        }
        .seo_set{
            margin: 20px 0;
        }
        .seo_wrap{
            display: flex;
            flex-wrap: wrap;
            border: 1px solid #ccc;
            margin: 20px 0;
            padding: 20px;
            .form-item {
                margin-left: 0;
                margin-right: 60px;
                .label{
                    width: 80px;
                }
                .co_w{
                    width: 66px;
                }
            }
        }
        .el-upload__tip{
            color: red;
        }
    }

</style>
